import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import ProgramareNoua from "@/views/ProgramareNoua.vue";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }

      if (to.hash) {
        return new Promise(resolve => {
          setTimeout(() => {
            const element = document.querySelector(to.hash)

            if (element) {
              const top = element.getBoundingClientRect().top + window.pageYOffset - 80

              resolve({
                x: 0,
                y: top
              })
            } else {
              resolve({ x: 0, y: 0 })
            }
          }, 300)
        })
      }

      return { x: 0, y: 0 }
    },
  routes: [
    {
      path: '/',
      redirect: 'comenzi'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/intrare-noua/:id',
      name: 'intrare-noua-by-id',
      component: () => import('../views/IntrareNoua.vue')
    },
    {
      path: '/intrare-noua',
      name: 'intrare-noua',
      component: () => import('../views/IntrareNoua.vue')
    },
    {
      path: '/devize',
      name: 'devize',
      component: () => import('../views/Devize.vue')
    },
    {
      path: '/programare-noua',
      name: 'programare-noua',
      component: ProgramareNoua
    },
    {
      path: '/comenzi',
      name: 'comenzi',
      component: () => import('../views/Comenzi.vue')
    },
    {
      path: '/comanda/:id',
      name: 'comanda',
      component: () => import('../views/Comanda-1.vue')
    },
    {
      path: '/deviz/:id',
      name: 'deviz',
      component: () => import('../views/Deviz.vue')
    },
    {
      path: '/deviz-simplu/:id',
      name: 'deviz-simplu',
      component: () => import('../views/DevizSimplu.vue')
    },
    {
      path: '/deviz-invoice/:id',
      name: 'deviz-invoice',
      component: () => import('../views/Deviz_Invoice.vue')
    },
    {
      path: '/deviz-oferta/:id',
      name: 'Deviz-Oferta',
      component: () => import('../views/Deviz_Oferta.vue')
    },
    {
      path: '/clienti',
      name: 'clienti',
      component: () => import('../views/Clienti.vue')
    },
    {
      path: '/programari',
      name: 'programari',
      component: () => import('../views/Programari.vue')
    },
    {
      path: '/links',
      name: 'links',
      component: () => import('../views/Links.vue')
    },
    {
      path: '/cars-data',
      name: 'cars-data',
      component: () => import('../views/CarsDataView.vue')
    },
    {
      path: '/setari',
      name: 'setari',
      component: () => import('../views/Settings.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  to.name === 'login'
    ? next()
    : store.state.auth.user.name
      ? next()
      : store.dispatch('check_login_by_cookie', next)
})

export default router
